import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';


import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import {saveAs as importedSaveAs} from "file-saver";

import { environment } from './../../environments/environment';
import { Collana } from '../models/Collana';


@Injectable()
export class CollanaService {

  constructor(
    private http: Http ) { }

  selectedCodice: string;

  get selected(): string {
    return this.selectedCodice;
  }
  set selected(codice: string) {
    this.selectedCodice = codice;
  }

  getCollana(codice: string) {
    console.log('getCollana', codice)
    return this.http.post(environment.server.url + '/collana/find-one', { codice: codice })
      .map(response => response.json())
      .catch(this.handleError)
  }

  search(opt) {
    console.log('collana service', opt)
    return this.http.post(environment.server.url + '/collana/search', opt)
      .map(response => response.json())
      .catch(this.handleError)
  }

  sort(c: Collana, books: any[]) {
    console.log(books);
    return this.http.post(environment.server.url + '/collana/sort', {
      eans: books,
      collana: {
        codice: c.codice,
        descrizione: c.descrizione
      }
    })
      .map(response => response.json())
      .catch(this.handleError)
  }

  load(codice: string, fuoricatalogo: boolean, exportcsv: boolean) {
    console.log(window.location.origin );
    if (exportcsv) {
      let options = new RequestOptions({ responseType: ResponseContentType.Blob });
      let wsuffix = '';
      if(environment.publisher == 'edb') {
         wsuffix = '/elzeviro/#';
      } else if(environment.publisher == 'marietti') {
         wsuffix = '/marietti/#';
      }
      return this.http.post(environment.server.url + '/collana/load', {
        codice: codice,
        fuoricatalogo: fuoricatalogo,
        exportcsv: exportcsv,
        linkurl: window.location.origin + wsuffix
      }, options)
        .map(response => {
          let fileBlob = response.blob();
          let blob = new Blob([fileBlob], {
            type: 'application/vnd.ms-excel'
          })
          return blob;
        })
        .catch(this.handleError)




    } else {
      return this.http.post(environment.server.url + '/collana/load', { codice: codice, fuoricatalogo: fuoricatalogo, exportcsv: exportcsv })
        .map(response => response.json())
        .catch((err) => Observable.throw(err))
    }
  }

  persist(wmodel: any) {
    console.log('persist', wmodel)
    return this.http.post(environment.server.url + '/collana/persist', { wmodel: wmodel })
      .map(response => response.json())
      .catch((err) => Observable.throw(err))
  }

  downloadFile(wq): Observable<File> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('q', wq);
    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    options.search = params;
    return this.http.get(environment.server.url + '/collana/download', options)
      .map(res => res.blob())
      .catch(this.handleError)
  }

  print(codice: string, ebook: boolean): Observable<any> {
    return this.http.post(environment.server.url + '/catalogo/export2synth', { "collanaCodice": codice })
      .map((res: any) => res)
      .flatMap((result: any) => {
        console.log(result);
        let options = new RequestOptions({
          responseType: ResponseContentType.Blob,
          method: RequestMethod.Post
        })
        // https://www.dehoniane.it/stampa-catalogo
        return this.http.post(environment.urlPortale + '/stampa-catalogo', { collana: codice, solocatalogo: true, ebook: ebook ? "true" : "false" }, options)
          .map(res => {
            let hwcd = res.headers.get('content-disposition');
            let filename = hwcd.split('filename=')[1].replace(new RegExp(/"/g), '');
            importedSaveAs(res.blob(), filename);
            return Observable.of({
              success: true
            })
          })
      })
      .catch(this.handleError)
  }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/collana.service.ts